<app-listing (selectedBoxChange)="newAppSelected($event)" [config]="config" [header]="header || 'Select an App'"></app-listing>
